import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import api from "../common/api";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import CustomToolbar from "../common/AddButton";
import GridActions from "../common/GridActions";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";

class Clients extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      q_rows: 10,
      isLoading: false,
      backdrop: false,
      menu: {
        open: false,
        anchorEl: ""
      },
      serverSideFilterList: [],
      filters: [[], [], [], [], [], ["Cliente negocios"], [], []],
      rowId: 0,
      contact_id: 0,
      orderColumn: "",
      orderOrder: "",
      client_types: []
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
  }

  async componentDidMount() {
    await this.getClientTypes();
    await this.changePage(
      1,
      this.state.filters,
      this.state.orderColumn,
      this.state.orderOrder,
      this.state.q_rows
    );
  }

  sort = (column, order) => {
    let temp = {};
    temp.column = column;
    temp.order = order;

    this.setState({ orderColumn: column, orderOrder: order });
    if (column === "type.name") {
      column = "client_type_id";
    }
    this.changePage(
      this.state.page,
      this.state.filters,
      column,
      order,
      this.state.q_rows
    );
  };

  changePage = (page, filterList, column, order, q_rows) => {
    this.setState({
      isLoading: true
    });

    var q = "";
    var client_type = "";
    var hansa_code = "";
    var deleted_at = 0;

    if (filterList[3].length !== 0) {
      q = filterList[3][0];
    }
    if (filterList[5].length !== 0) {
      client_type = filterList[5];
    }
    if (filterList[2].length !== 0) {
      hansa_code = filterList[2];
    }
    if (filterList[7].length !== 0) {
      if (filterList[7][0] === "Si") deleted_at = 1;
    }

    var orderColumn = column !== "" ? column : "";
    var orderOrder = order !== "" ? order : "";

    const token = localStorage.getItem("userToken");

    axios
      .get(
        api
          .clients()
          .index(
            page,
            q,
            client_type,
            orderColumn,
            orderOrder,
            q_rows,
            hansa_code,
            deleted_at
          ),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        this.setState({
          isLoading: false,
          page: res.data.current_page,
          data: res.data.data,
          count: res.data.total,
          rowsPerPage: res.data.per_page,
          serverSideFilterList: filterList,
          filters: filterList
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  getClientTypes = async () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.client_types, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        // array list of options for the dropdown
        const options = res.data.map(item => item.name);
        this.setState({ client_types: options });
      })
      .catch(err => {
        console.log(err);
      });
  };
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 0px 0px 0px",
            fontSize: "0.75rem",
            maxWidth: "10rem"
          }
        },
        MUIDataTable: {
          responsiveStacked: {
            overflow: "unset",
            overflowX: "unset"
          }
        }
      }
    });
  handleRestore = id => {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    axios
      .post(api.clients().restore(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        this.setState({
          message: "Cliente rehabilitado con éxito!",
          dialogOpen: true
        });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
        this.setState({ rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true, dialogOpen: true });
        this.setState({ delete_id: "" });
        this.setState({
          message:
            "Ha ocurrido un error al rehabilitar el cliente, contacte a su administrador."
        });
      });
  };

  handleDelete(id) {
    this.setState({ delete_id: id });
    var client = "";
    id = this.state.contact_id;
    this.state.data.map((val, idx) => {
      if (val.contact.id === id) {
        client = val.fantasy_name;
        this.setState({ delete_id: val.id });
      }
    });
    var message = "";
    if (client !== "") {
      message =
        "Está a punto de dar de baja al cliente " + client + ". ¿Está seguro?";
    } else {
      this.setState({ errors: true });
      message = "Hubo un problema al dar de baja al cliente.";
    }
    this.setState({ message: message, dialogOpen: true });
  }

  handleRedirect(e) {
    e.preventDefault();
    window.location.href = `/clients`;
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  confirmDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(
        api.clients().delete(this.state.delete_id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "client[id]": this.state.delete_id } }
      )
      .then(res => {
        this.setState({ message: "Cliente dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "", rowId: "" });
        return true;
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: err.response.data.errors["client.id"] });
        return false;
      });
  }

  handleMenuClick(event, id) {
    var menu = {};
    menu.open = true;
    menu.anchorEl = event.currentTarget;
    this.state.data.map((val, idx) => {
      if (val.id === id) {
        this.setState({ contact_id: val.contact.id, client_id: val.id });
      }
    });
    this.setState({ menu: menu, rowId: id });
  }

  handleMenuClose() {
    var menu = {};
    menu.open = false;
    menu.anchorEl = null;
    this.setState({ menu: menu, contact_id: "" });
  }

  handleFilterSubmit = (page, filterList) => () => {
    page = 0;
    this.setState({ page });
    this.changePage(
      page,
      filterList,
      this.state.orderColumn,
      this.state.orderOrder,
      this.state.q_rows
    );
  };

  handleDownload = () => {
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    axios
      .post(api.clients().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "id" ? this.state.orderOrder : null
        }
      },
      {
        name: "contact.id",
        options: {
          display: false,
          filter: false
        }
      },
      {
        name: "contact.hansa_code",
        label: "Cod. Hansa",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[2],
          sort: false,
          display: true
        }
      },
      {
        name: "business_name",
        label: "Nombre comercial",
        options: {
          filter: true,
          filterType: "textField",
          filterList: this.state.filters[3],
          sort: true,
          sortDirection:
            this.state.orderColumn === "business_name"
              ? this.state.orderOrder
              : null
        }
      },
      {
        name: "fantasy_name",
        label: "Nombre de fantasia",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "fantasy_name"
              ? this.state.orderOrder
              : null
        }
      },
      {
        name: "type.name",
        label: "Tipo de Cliente",
        options: {
          display: true,
          filter: true,
          sort: true,
          sortDirection:
            this.state.orderColumn === "type.name"
              ? this.state.orderOrder
              : null,
          filterList: this.state.filters[5],
          filterOptions: this.state.client_types
        }
      },
      {
        name: "contact.email",
        label: "Email",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "email" ? this.state.orderOrder : null
        }
      },
      {
        name: "deleted_at",
        label: "Dado de baja",
        options: {
          filter: true,
          filterType: "select",
          filterOptions: {
            names: ["Si", "No"]
          },
          sort: false,
          display: false,
          filterList: this.state.filters[7]
        }
      },
      {
        name: "sap_code",
        label: "Código SAP",
        options: {
          filter: false,
          sort: false
        }
      },
      {
        name: "sap_active",
        label: "Activo SAP",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return value ? "Si" : "No";
          }
        }
      },
      {
        name: "sap_dimension",
        label: "Dimensión SAP",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "actions",
        label: "Acciones",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: value => {
            return {
              style: {
                textAlign: "center"
              }
            };
          },
          customBodyRender: (value, tableMeta, updateValue) => {
            var id = tableMeta.rowData[0];
            var deleted_at = tableMeta.rowData[7];
            if (
              deleted_at !== "" &&
              deleted_at !== undefined &&
              deleted_at !== null
            )
              return (
                <Button
                  variant="contained"
                  onClick={() => this.handleRestore(id)}
                >
                  Rehabilitar
                </Button>
              );

            return (
              <GridActions
                id={id}
                module="clients"
                actions={{
                  edit: { url: "client/edit/" + id, action: "edit" },
                  view: { url: "client/" + id + "/1", action: "view" },
                  audit: { url: "clients/audit/" + this.state.rowId },
                  subcontacts: { url: "subcontacts/" + this.state.contact_id },
                  client_routes: {
                    url: "client_routes/" + this.state.client_id
                  },
                  client_expenses: {
                    url: "client_expenses/" + this.state.client_id
                  },
                  geodefender_fines: {
                    url: "/geodefender-fines/" + this.state.client_id
                  },
                  client_charge_invoices: {
                    url: "/client-charge-invoices/" + this.state.client_id
                  },
                  invoices: {
                    url: "/invoices/" + this.state.client_id
                  }
                }}
                onDelete={this.handleDelete}
                onMenuClick={this.handleMenuClick}
                onMenuClose={this.handleMenuClose}
                open={this.state.menu.open}
                anchorEl={this.state.menu.anchorEl}
                hasMenu={true}
              />
            );
          }
        }
      }
    ];

    const { data, count, isLoading } = this.state;

    const options = {
      filter: true,
      search: false,
      selectableRows: true,
      filterType: "dropdown",
      customToolbar: () => {
        return <CustomToolbar url="new" />;
      },
      responsive: "stacked",
      serverSide: true,
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      onFilterDialogOpen: () => {
        console.log("filter dialog opened");
      },
      onFilterDialogClose: () => {
        console.log("filter dialog closed");
      },
      onFilterChange: (column, filterList, type) => {
        if (type === "chip") {
          this.handleFilterSubmit(this.state.page, filterList)();
        }
      },
      customFilterDialogFooter: filterList => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={this.handleFilterSubmit(this.state.page, filterList)}
            >
              Aplicar
            </Button>
          </div>
        );
      },
      count: count,
      onChangeRowsPerPage: numberOfRows => {
        this.setState({ isLoading: true, q_rows: numberOfRows, data: [] });
        this.changePage(
          this.state.page,
          this.state.filters,
          this.state.orderColumn,
          this.state.orderOrder,
          numberOfRows
        );
      },
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }
        this.sort(changedColumn, order);
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ data: [] });
            this.changePage(
              tableState.page + 1,
              this.state.filters,
              this.state.orderColumn,
              this.state.orderOrder,
              this.state.q_rows
            );
            break;
          default:
            break;
        }
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? (
            <CircularProgress />
          ) : (
            "No hay resultados"
          ),
          toolTip: "Ordenar",
          columnHeaderTooltip: column => `Ordenar para ${column.label}`
        },
        filter: {
          all: "Todos los resultados",
          title: "Tus filtros",
          reset: "Resetear"
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Exportar XLS",
          print: "Imprimir",
          viewColumns: "Ver columnas",
          filterTable: "Filtros"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.rowId === "" ? (
                      <div>
                        <Button
                          onClick={e => {
                            this.handleRedirect(e);
                          }}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={this.confirmDelete.bind(this)}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <MuiThemeProvider theme={this.getMuiTheme()}>
              <Backdrop
                open={this.state.backdrop}
                onClick={this.handleCloseBackdrop}
                style={{ zIndex: 10000, color: "#3f51b5" }}
              >
                <CircularProgress color="inherit" />{" "}
                <Typography className="ml-2" variant="h5" color="primary">
                  Descargando...
                </Typography>
              </Backdrop>
              <MUIDataTable
                title={
                  <Typography variant="h6">
                    Lista de clientes
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: "relative", top: 4 }}
                      />
                    )}
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Clients;
